import css from 'styled-jsx/css';

const staticStyles = css`
  .Document__item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 40px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    transition: all 0.2s;
    cursor: zoom-in;

    &:hover {
      border-color: #2196F3;
      box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
    }

    &-preview {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 60px;
        height: 40px;
        border-radius: 4px;
        object-fit: cover;
      }

      embed {
        width: 100%;
        height: 100%;
      }
    }

    &-placeholder {
      font-size: 12px;
      color: #999;
      text-align: center;
    }

    &::after {
      content: '';
      position: absolute;
      top: -5px;
      right: -5px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid #fff;
    }

    &--unverified::after {
      background-color: rgb(245, 166, 35);
    }

    &--verified::after {
      background-color: rgb(56, 151, 0);
    }
  }
`;

export { staticStyles };
